export const MemberTrainOrderCn = {
    xunjiadang:'培训订单',
    peixunfuwu:'请输入服务名称或订单号关键字',
    jiage:'搜索',
    zhuantai:'状态',
    caozuo:'操作',
    pingjiazhuantai:'价格',
    dingdangneirong:'订单内容'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/MemberTrainOrder/MemberTrainOrderCn.js